export default __webpack_public_path__ + "static/media/undraw_everyday_design_gy.0defac6b.svg";